import React, { useEffect } from 'react';

import { ChooseService as ChooseServiceView } from './choose-service';
import { useCvBonusInfo } from '../../../../../hooks';
import { useCvInfoModal } from '../../../../../hooks/use-cv-info-modal';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { EcpServices } from '../ecp-locator.models';
import { ecpStoresCached } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { ChooseServiceContainerProps } from './choose-service.models';
import { Preloader } from '../../../../common/preloader';

export const ChooseService = ({
  isFitted,
  ecpProfile,
  isLoading,
  isLoggedIn,
  appointment,
}: ChooseServiceContainerProps): JSX.Element => {
  const isCv = ecpProfile?.profile?.servicesAvailability?.controlVisitAvailability ?? false;
  const isAec = ecpProfile?.profile?.servicesAvailability?.annualEyeCheckAvailability ?? false;
  const { cvBonusPoints, cvBonusEndDate, fromDays, toDays, code, isLoading: isCvBonusLoading } = useCvBonusInfo(isCv);
  const { handleCvDetailsClick } = useCvInfoModal({
    points: cvBonusPoints,
    fromDays,
    toDays,
    endDate: cvBonusEndDate,
    code,
    isLoading: isCvBonusLoading,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect((): void => {
    ecpStoresCached([]);
  }, []);

  useEffect((): void => {
    const source = searchParams.get('source');
    searchParams.set('ecpService', EcpServices.fit);
    const newSearchParams = searchParams.toString();

    if (source === 'ozon') {
      navigate(`${location.pathname}?${newSearchParams}`, { replace: true });
    }
  }, [location, navigate, searchParams]);

  return (
    <>
      {isLoading ? <Preloader /> : (
        <ChooseServiceView
          isCv={isCv}
          isAec={isAec}
          isFitted={!!isFitted}
          cvBonusPoints={cvBonusPoints}
          cvBonusEndDate={cvBonusEndDate}
          onCvDetailsClick={handleCvDetailsClick}
          storeGroupCode={code}
          isCvCodeLoading={isCvBonusLoading}
          isLoggedIn={isLoggedIn}
          appointment={appointment}
        />
      )}
    </>
  );
};
